import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Icon } from '@elements';
import close from '@images/close.image.svg';
import { HeaderBox, StyledIconButton, StyledIconButtonWrapper } from './modal-title.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsx(Typography, {
    variant: "h4",
    component: "p",
    color: "#FFF",
    children: children
  }) : children;
  return /*#__PURE__*/_jsx(HeaderBox, {
    position: "relative",
    children: /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 2,
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        xs: 12,
        display: "flex",
        justifyContent: "center",
        children: titleContent
      }), /*#__PURE__*/_jsx(Box, {
        position: "absolute",
        right: "24px",
        top: "15px",
        children: /*#__PURE__*/_jsx(StyledIconButtonWrapper, {
          children: /*#__PURE__*/_jsx(StyledIconButton, {
            onClick: handleClose,
            size: "large",
            children: /*#__PURE__*/_jsx(Icon, {
              height: 28,
              src: close,
              width: 28
            })
          })
        })
      })]
    })
  });
};

ModalTitle.displayName = 'ModalTitle';
export { ModalTitle };